module.exports = __webpack_public_path__ + "static/media/warning-5s.d9a46637.mp3";